import CoursewareAI from './index.vue';

export default [
  {
    path: '/coursewareai',
    name: 'CoursewareAI',
    component: CoursewareAI,
    meta: {
      title: '互动课件管理'
    }
  },
];



// WEBPACK FOOTER //
// ./src/views/CoursewareAI/index.js